import { Modal } from "@/shared/ui/modal"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { SubmitHandler, useForm } from "react-hook-form"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { closeRecreateApiKeyModal, fetchRecreateApiKey, selectIsRecreateApiKeyModalOpen, selectOnRecreate } from "../../model"

export const RecreateApiKeyModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsRecreateApiKeyModalOpen)
    const onRecreate = useAppSelector(selectOnRecreate)

    const handleClose = () => {
        dispatch(closeRecreateApiKeyModal())
    }

    const onSubmit: SubmitHandler<{}> = async () => {
        await new Promise((res, rej) => {
            dispatch(fetchRecreateApiKey())
                .unwrap()
                .then(() => {
                    notify.success('API-Ключ успешно обновлен')
                    reset()
                    onRecreate?.()
                    handleClose()
                    res('')
                }).catch((e) => {
                    notify.error(getErrorMessage(e))
                    rej()
                })
        })
    }

    const {
        handleSubmit,
        reset,
        formState: {
            isSubmitting
        }
    } = useForm()

    return (
        <Modal
            isOpen={isOpen}
            title={(
                <div>
                    Пересоздание <br />
                    API-Ключа <br />
                </div>
            )}
            onRequestClose={handleClose}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <div>
                    Вы уверены, что хотите пересоздать API-Ключ?
                </div>
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} className="form_cancel_button">
                        Отменить
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button" type="submit">
                        Продолжить
                    </button>
                </div>
            </form>
        </Modal>
    )
}